import { FC } from 'react';
import { Image, ThemeImageProps } from '@base/lib/ThemeImage';
import { get375CssValue } from 'base/utils/dom-size';
import { isPhone } from 'base/utils/client';
import cn from 'classnames';
import styles from './index.module.less';

type IProps = ThemeImageProps & {
    toggle: string;
}

export const HoverTogglePic: FC<IProps> = props => {
    const {
        className,
        src,
        toggle,
        href,
        target,
        ...rest
    } = props;

    return isPhone || !toggle ? (
        <Image
            className={className}
            src={src}
            href={href}
            target={target}
            {...rest}
        />
    ) : (
        <div
            className={cn(className, styles.pic, 'relative overflow')}
            style={{ width: rest.fixed ? get375CssValue(rest.width) : void 0 }}
        >
            <Image
                className={styles.bottom}
                src={src}
                {...rest}
            />
            <Image
                className={cn(styles.top, 'sw-overlay')}
                src={toggle}
                href={href}
                target={target}
                {...rest}
                background={false}
                absolute
            />
        </div>
    )
};
